
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollDetailsDialog extends Serenity.EntityDialog<PayrollDetailsRow, any> {
        protected getFormKey() { return PayrollDetailsForm.formKey; }
        protected getIdProperty() { return PayrollDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return PayrollDetailsRow.localTextPrefix; }
        protected getService() { return PayrollDetailsService.baseUrl; }
        protected getDeletePermission() { return PayrollDetailsRow.deletePermission; }
        protected getInsertPermission() { return PayrollDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PayrollDetailsRow.updatePermission; }

        protected form = new PayrollDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.Earnings);
            q.hideEditorLabel(this.form.Deductions);
            q.hideEditorToolbar(this.form.Earnings);
            q.hideEditorToolbar(this.form.Deductions);
            q.hideEditorCategoryLabel(this.form.EmployeeName.element);
            q.SetCategorySixColumn(this.form.Deductions);
            q.SetCategorySixColumn(this.form.Earnings);
            q.SetCategorySixColumn(this.form.EmployeeCode);
            q.SetCategorySixColumn(this.form.Present);
            q.hideCategorylinks(this.element)
            q.setTextRightAlign(this.form.NetSalary);
            q.setTextRightAlign(this.form.GrossSalary);
            q.setTextRightAlign(this.form.Present);
            q.setTextRightAlign(this.form.Absent);
            q.setTextRightAlign(this.form.HalfDay);
            q.setTextRightAlign(this.form.OnLeave);
        }
        protected override onDialogOpen() {
            super.onDialogOpen();
            var employeedetails = this.form.EmployeeDetails.getItems();
            if (employeedetails != null && employeedetails.length > 0) {
                for (var i = 0; i < employeedetails.length; i++) {
                    var detail = employeedetails[i]
                    if (detail.Type == 1)
                        this.form.Earnings.adddetail(detail);
                    else if (detail.Type == 2)
                        this.form.Deductions.adddetail(detail);
                }
            }
        }
    }
}
